import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-emoji">🎮</div>
        <h1>Oops! Page Not Found</h1>
        <p>Looks like this level doesn't exist yet!</p>
        <div className="not-found-actions">
          <Link to="/dashboard" className="not-found-btn primary">
            Go to My Games
          </Link>
          <Link to="/" className="not-found-btn secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};
